export const bytesToMegabytes = (bytes: number): number => {
    return Number.parseFloat((bytes / (1024 * 1024)).toFixed(2)); // 1 Mo = 1024 * 1024 octets
}

export const convertBytesToStringMegabytes = (bytes: number): string => {
    return `${bytesToMegabytes(bytes)} MB`;
}